import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import host from "../../global";
import {
  Trash,
  ChevronDown,
  Timer,
  Save,
  Plus,
  X,
  GripVertical,
  Play,
  Pause,
  Turtle,
  ArrowLeft,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "../../hooks/useTheme"



const AssessmentConfig = () => {
  const [jobPositions, setJobPositions] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSavingQuestions, setIsSavingQuestions] = useState(false);
  const accessToken = sessionStorage.getItem("accessToken");
  const [selectedID, setSelectedID] = useState("");
  const [CodingTimeLimit, setCodingTimeLimit] = useState(10);
  const [isMCQIncluded, setIsMCQIncluded] = useState(false);
  const [isCodingIncluded, setIsCodingIncluded] = useState(false);
  const [codingSets, setCodingSets] = useState([]);
  const [codingJudgingCriteria, setCodingJudgingCriteria] = useState("NA");
  const [selectedCodingSet, setSelectedCodingSet] = useState("NA");
  const [resumeScoreThreshold, setResumeScoreThreshold] = useState();
  const [interview_timelimit, setInterviewTimeLimit] = useState(null);
  const [selectedSet, setSelectedSet] = useState("NA");
  const [sets, setSets] = useState([]);
  const [jobdesc, setJobdesc] = useState("");
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isCustomQuestionsIncluded, setIsCustomQuestionsIncluded] =
    useState(false);
  const [customQuestions, setCustomQuestions] = useState("");
  const [editedQuestions, setEditedQuestions] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [assessmentSequence, setAssessmentSequence] = useState([]);
  const [draggedItem, setDraggedItem] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [voices, setVoices] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState(null);
  const [audio, setAudio] = useState(null);
  const [jobData, setJobData] = useState("");
  const location = useLocation();
  const isReadonly = location.state?.readonly || false;
  const [editedJobdesc, setEditedJobdesc] = useState(null);
  const [isEditingJD, setIsEditingJD] = useState(true);
  const [jobRole, setJobRole] = useState("");
  const [isVideoIncluded, setIsVideoIncluded] = useState(false);
  const [isAdminAuthorized, setIsAdminAuthorized] = useState(null);
  const navigate = useNavigate();
  const [showAddQuestionsSection, setShowAddQuestionsSection] = useState(false);
  const [testPermissions, setTestPermissions] = useState({
    mcq_enabled: false,
    coding_enabled: false,
    behavioral_enabled: false,
    typing_enabled: false,
    candidate_form_enabled: false
  });
  const [isTypingIncluded, setIsTypingIncluded] = useState(false);
  const [typingTimeLimit, setTypingTimeLimit] = useState(1);
  const [isBehavioralIncluded, setIsBehavioralIncluded] = useState(false);
  const [selectedBehavioralSet, setSelectedBehavioralSet] = useState("NA");
  const [behavioralSets, setBehavioralSets] = useState([]);
  const [questionType, setQuestionType] = useState("");
  const [isCandidateFormIncluded, setIsCandidateFormIncluded] = useState(false);

  const { theme } = useTheme();

  const handleAddQuestion = () => {
    if (questions.length >= 10) {
      alert("Maximum 10 custom questions allowed");
      return;
    }
    setShowAddQuestionsSection(true);
    setCustomQuestions("");
    setQuestions(
      questions.map((question) => ({
        ...question,
        isNew: false,
      }))
    );
    setEditedQuestions(
      editedQuestions.map((question) => ({
        ...question,
        isNew: false,
      }))
    );
  };
  const handleCancelAddQuestions = () => {
    setShowAddQuestionsSection(false);
    setCustomQuestions("");
    setErrorMessage("");
  };

  useEffect(() => {
    const checkAdminAuthorization = async () => {
      try {
        const response = await axios.get(`${host}/check_permissions_for_jd`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setIsAdminAuthorized(response.data.is_authorized);
        setTestPermissions({
          mcq_enabled: response.data.mcq_enabled || false,
          coding_enabled: response.data.coding_enabled || false,
          behavioral_enabled: response.data.behavioral_enabled || false,
          typing_enabled: response.data.typing_enabled || false,
          candidate_form_enabled: response.data.candidate_form_enabled || false,
        });
        console.log("Admin authorization status:", response.data.is_authorized);
        console.log("Test permissions:", response.data);
      } catch (error) {
        console.error("Error checking admin ID:", error);
        if (error.response) {
          const { status, data } = error.response;
          if (status === 401) {
            toast.error("Unauthorized: Invalid token");
            sessionStorage.removeItem("accessToken");
          } else {
            toast.error(
              `Error: ${data.detail || "Failed to check admin status"}`
            );
          }
        } else {
          toast.error("Network error: Unable to reach the server");
        }
        setIsAdminAuthorized(false);
      }
    };

    if (accessToken) {
      checkAdminAuthorization();
    } else {
      setIsAdminAuthorized(false);
    }
  }, [accessToken]);

  useEffect(() => {
    const fetchInitialData = async () => {
      if (location.state?.jobId) {
        setSelectedID(location.state.jobId);
        await handleJobPositionChange({
          target: { value: location.state.jobId },
        });
        // setExpanded(true);
        setIsEditingJD(true);
      }
    };
    fetchInitialData();
  }, [location]);

  console.log(location.state);
  const handleLanguageChange = async (language) => {
    setSelectedLanguage(language);
    setSelectedVoice(null);
    try {
      const response = await axios.get(`${host}/voices/${language}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setVoices(response.data);
    } catch (error) {
      console.error("Error fetching voices:", error);
      setVoices([]);
    }
  };
  useEffect(() => {
    return () => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    };
  }, [audio]);
  useEffect(() => {
    axios
      .get(`${host}/get_configurations`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        handleLanguageChange(response.data.language);
        setLanguages(response.data.available_languages);
        setSelectedLanguage(response.data.language);
        setVoices([
          { name: response.data.voice_name, type: response.data.voice_type },
        ]);
        setSelectedVoice({
          name: response.data.voice_name,
          type: response.data.voice_type,
        });
        setResumeScoreThreshold(response.data.resume_score_threshold);
        setIsVideoIncluded(response.data.video_included);
      })
      .catch((error) => console.error("Error fetching configurations:", error));
  }, []);

  useEffect(() => {
    // If jobData is loaded and has a valid assessment sequence, use it
    if (
      selectedID &&
      jobData &&
      jobData.assessment_sequence?.length > 0 &&
      !isDataLoaded
    ) {
      setAssessmentSequence(jobData.assessment_sequence);
      return;
    }

    // Build sequence like CreateJD
    const tests = [];
    if (testPermissions.mcq_enabled && isMCQIncluded) tests.push("mcq");
    if (testPermissions.coding_enabled && isCodingIncluded) tests.push("coding");
    if (testPermissions.typing_enabled && isTypingIncluded) tests.push("typing");
    if (testPermissions.behavioral_enabled && isBehavioralIncluded) tests.push("behavioral");

    let sequence = ["interview"];
    if (jobData?.assessment_sequence?.length > 0) {
      const existingTests = jobData.assessment_sequence.filter(t => t !== "interview");
      sequence = existingTests.length === tests.length ? ["interview", ...existingTests] : ["interview", ...tests];
    } else {
      sequence.push(...tests);
    }

    setAssessmentSequence(sequence);
  }, [
    isMCQIncluded,
    isCodingIncluded,
    isTypingIncluded,
    isBehavioralIncluded,
    selectedID,
    jobData,
    isDataLoaded,
    testPermissions,
  ]);
  const handleDragStart = (e, item) => {
    setDraggedItem(item);
    e.target.style.opacity = "0.5";
  };
  const handleDragEnd = (e) => {
    e.target.style.opacity = "1";
    setDraggedItem(null);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleDrop = (e, targetItem) => {
    e.preventDefault();
    if (draggedItem === targetItem) return;
    const newSequence = [...assessmentSequence];
    const draggedIndex = newSequence.indexOf(draggedItem);
    const targetIndex = newSequence.indexOf(targetItem);
    newSequence.splice(draggedIndex, 1);
    newSequence.splice(targetIndex, 0, draggedItem);
    setAssessmentSequence(newSequence);
  };
  const handleAccordionChange = () => {
    setExpanded(!expanded);
  };
  useEffect(() => {
    const fetchJobPositions = async () => {
      try {
        const response1 = await axios.get(`${host}/getjdpositions`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setJobPositions(response1.data);
        const response2 = await axios.get(`${host}/orgadmin/get_setnames`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setCodingSets(response2.data.coding_sets);
        setSets(response2.data.set_names);
        setBehavioralSets(response2.data.behavioral_sets || []);
        setIsLoading(false);
      } catch (error) {
        if (error.response) {
          const status = error.response.status;
          const detail = error.response.data.detail;
          if (status === 401) {
            await new Promise((resolve) => {
              sessionStorage.removeItem("accessToken");
              resolve();
            });
            toast.error(`Unauthorized: ${detail}`);
          } else if (status === 404) {
            toast.warning(`Not Found: ${detail}`);
          } else {
            toast.error(`Error: ${detail}`);
          }
        } else {
          toast.error("An unexpected error occurred. Please try again.");
        }
        setIsLoading(false);
      }
    };
    fetchJobPositions();
  }, [accessToken]);
  const handleTextareaChange = (e, field, section, index) => {
    const newValue = e.target.value;
    const updatedJobdesc = { ...editedJobdesc };

    if (field === "minExp" || field === "maxExp") {
      updatedJobdesc[field] = newValue === "" ? 0 : parseInt(newValue, 10);
    } else if (section && index !== undefined) {
      updatedJobdesc[section][index] = newValue;
    } else if (section) {
      updatedJobdesc[section][field] = newValue;
    } else {
      updatedJobdesc[field] = newValue;
    }
    setEditedJobdesc(updatedJobdesc);
  };

  const handleAddListItem = (section, category) => {
    const updatedJobdesc = { ...editedJobdesc };

    if (section === "Roles_and_Responsibilities") {
      if (!updatedJobdesc.Roles_and_Responsibilities) {
        updatedJobdesc.Roles_and_Responsibilities = [];
      }
      updatedJobdesc.Roles_and_Responsibilities.push("");
    } else if (section === "Required_Skills") {
      if (!updatedJobdesc.Required_Skills) {
        updatedJobdesc.Required_Skills = { Easy: [], Medium: [], Hard: [] };
      }
      if (!updatedJobdesc.Required_Skills[category]) {
        updatedJobdesc.Required_Skills[category] = [];
      }
      updatedJobdesc.Required_Skills[category].push("");
    } else if (section === "Tools_and_Technologies") {
      if (!updatedJobdesc.Tools_and_Technologies) {
        updatedJobdesc.Tools_and_Technologies = [];
      }
      updatedJobdesc.Tools_and_Technologies.push("");
    } else if (section === "GoodtoHave") {
      if (!updatedJobdesc.GoodtoHave) {
        updatedJobdesc.GoodtoHave = [];
      }
      updatedJobdesc.GoodtoHave.push("");
    }
    setEditedJobdesc(updatedJobdesc);
  };

  const handleRemoveListItem = (section, category, index) => {
    const updatedJobdesc = { ...editedJobdesc };

    if (section === "Roles_and_Responsibilities") {
      updatedJobdesc.Roles_and_Responsibilities.splice(index, 1);
    } else if (section === "Required_Skills") {
      updatedJobdesc.Required_Skills[category].splice(index, 1);
    } else if (section === "Tools_and_Technologies") {
      updatedJobdesc.Tools_and_Technologies.splice(index, 1);
    } else if (section === "GoodtoHave") {
      updatedJobdesc.GoodtoHave.splice(index, 1);
    }

    setEditedJobdesc(updatedJobdesc);
  };

  const formatJobDescriptionForEditing = (jobRole) => {
    if (!editedJobdesc) return null;

    if (questionType === "screening" || questionType === "Initial Screening" || questionType === "Bring Your Own Questions") {
      const isExperienceInvalid = editedJobdesc.minExp > editedJobdesc.maxExp;

      return (
        <div>
          <div className="mb-5">
            <label className="block mb-2 font-semibold dark:text-white text-textSecondary">
              Experience Range:
            </label>
            <div className="flex gap-2">
              <input
                type="number"
                min={0}
                value={editedJobdesc.minExp}
                onChange={(e) => handleTextareaChange(e, "minExp")}
                disabled={isReadonly}
                className={`w-20 dark:text-gray-300 text-textSecondary ${theme === 'dark' ? 'glass-effect' : 'bg-bgPrimary'} focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 px-2`}
              />
              <span className="self-center dark:text-gray-300 text-textSecondary">-</span>
              <input
                type="number"
                min={0}
                value={editedJobdesc.maxExp}
                onChange={(e) => handleTextareaChange(e, "maxExp")}
                disabled={isReadonly}
                className={`w-20 dark:text-gray-300 text-textSecondary ${theme === 'dark' ? 'glass-effect' : 'bg-bgPrimary'} focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 px-2`}
              />
              <span className="self-center dark:text-white text-textSecondary">years</span>
            </div>
            {isExperienceInvalid && (
              <p className="text-red-400 text-sm mt-2">
                Maximum experience must be greater than minimum experience.
              </p>
            )}
          </div>

          <div className="mb-5">
            <label className="block mb-2 font-semibold dark:text-white text-textSecondary">
              Job Description:
            </label>
            <textarea
              value={
                editedJobdesc.Raw_Job_Description ??
                editedJobdesc.job_description ??
                ""
              }
              disabled={isReadonly}
              onChange={(e) => {
                const updatedJobdesc = { ...editedJobdesc };

                if ("Raw_Job_Description" in updatedJobdesc) {
                  updatedJobdesc.Raw_Job_Description = e.target.value;
                }
                else if ("job_description" in updatedJobdesc) {
                  updatedJobdesc.job_description = e.target.value;
                }
                else {
                  updatedJobdesc.Raw_Job_Description = e.target.value;
                }

                setEditedJobdesc(updatedJobdesc);
              }}
              className={`flex-1 w-full ${theme === 'dark' ? 'text-gray-300 glass-effect' : 'text-textSecondary bg-bgPrimary'} focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 px-2 min-h-[200px]`}
              placeholder="Enter job description..."
            />
          </div>
        </div>
      );
    }

    const experience = (editedJobdesc.minExp + editedJobdesc.maxExp) / 2;
    const isExperienceInvalid = editedJobdesc.minExp > editedJobdesc.maxExp;

    return (
      <div>
        {/* <div className="mb-5">
          <label className="block mb-2 font-semibold text-white">Position:</label>
          <input
            type="text"
            value={jobRole}
            disabled
            className="text-gray-300 w-full glass-effect focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 px-2"
          />
        </div> */}

        <div className="mb-5">
          <label className="block mb-2 font-semibold dark:text-white text-textSecondary">
            Experience Range:
          </label>
          <div className="flex gap-2">
            <input
              type="number"
              min={0}
              value={editedJobdesc.minExp}
              onChange={(e) => handleTextareaChange(e, "minExp")}
              disabled={isReadonly}
              className={`w-20 dark:text-gray-300 text-textSecondary ${theme === 'dark' ? 'glass-effect' : 'bg-bgPrimary'} focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 px-2`}
            />
            <span className="self-center text-gray-300">-</span>
            <input
              type="number"
              min={0}
              value={editedJobdesc.maxExp}
              onChange={(e) => handleTextareaChange(e, "maxExp")}
              disabled={isReadonly}
              className={`w-20 dark:text-gray-300 text-textSecondary ${theme === 'dark' ? 'glass-effect' : 'bg-bgPrimary'} focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 px-2`}
            />
            <span className="self-center dark:text-white text-textSecondary">years</span>
          </div>
          {isExperienceInvalid && (
            <p className="text-red-400 text-sm mt-2">
              Maximum experience must be greater than minimum experience.
            </p>
          )}
        </div>

        {/* Required Skills */}
        <div className="mb-5">
          <div className="flex justify-between items-center mb-3">
            <label className="font-semibold dark:text-white text-textSecondary">Required Skills:</label>
            <button
              onClick={() =>
                handleAddListItem(
                  "Required_Skills",
                  experience < 4 ? "Medium" : "Hard"
                )
              }
              disabled={isReadonly}
              className={`text-green-400 hover:text-green-300 flex items-center ${isReadonly ? "hidden" : ""
                }`}
            >
              <Plus size={16} className="mr-1" />
              Add Skill
            </button>
          </div>
          <div>
            {experience < 4
              ? editedJobdesc.Required_Skills?.Medium?.map((skill, i) => (
                <div key={i} className="mb-2 dark:text-gray-300 text-textSecondary flex items-center">
                  <span className="w-8 text-right pr-2">{i + 1}.</span>
                  <textarea
                    value={skill}
                    disabled={isReadonly}
                    onChange={(e) => {
                      const newSkills = [
                        ...editedJobdesc.Required_Skills.Medium,
                      ];
                      newSkills[i] = [e.target.value];
                      const updatedJobdesc = { ...editedJobdesc };
                      updatedJobdesc.Required_Skills.Medium = newSkills;
                      setEditedJobdesc(updatedJobdesc);
                    }}
                    className={`flex-1 ${theme === 'dark' ? 'text-gray-300 px-2 glass-effect' : "text-textSecondary bg-bgPrimary px-2"} focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 min-h-[60px]`}
                  />
                  <button
                    onClick={() =>
                      handleRemoveListItem("Required_Skills", "Medium", i)
                    }
                    className={`ml-2 text-red-400 hover:text-red-300 ${isReadonly ? "hidden" : ""
                      }`}
                    disabled={isReadonly}
                  >
                    <X size={16} />
                  </button>
                </div>
              ))
              : editedJobdesc.Required_Skills?.Hard?.map((skill, i) => (
                <div key={i} className="mb-2 dark:text-gray-300 text-textSecondary flex items-center">
                  <span className="w-8 text-right pr-2">{i + 1}.</span>
                  <textarea
                    value={skill}
                    disabled={isReadonly}
                    onChange={(e) => {
                      const newSkills = [
                        ...editedJobdesc.Required_Skills.Hard,
                      ];
                      newSkills[i] = [e.target.value];
                      const updatedJobdesc = { ...editedJobdesc };
                      updatedJobdesc.Required_Skills.Hard = newSkills;
                      setEditedJobdesc(updatedJobdesc);
                    }}
                    className={`flex-1 ${theme === 'dark' ? 'text-gray-300 px-2 glass-effect' : "text-textSecondary bg-bgPrimary px-2"} focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 min-h-[60px]`}
                  />
                  <button
                    onClick={() =>
                      handleRemoveListItem("Required_Skills", "Hard", i)
                    }
                    className={`ml-2 text-red-400 hover:text-red-300 ${isReadonly ? "hidden" : ""
                      }`}
                    disabled={isReadonly}
                  >
                    <X size={16} />
                  </button>
                </div>
              ))}
          </div>
        </div>

        {/* Roles & Responsibilities */}
        <div className="mb-5">
          <div className="flex justify-between items-center mb-3">
            <label className="font-semibold dark:text-white text-textSecondary">
              Roles & Responsibilities:
            </label>
            <button
              onClick={() => handleAddListItem("Roles_and_Responsibilities")}
              className={`text-green-400 hover:text-green-300 flex items-center ${isReadonly ? "hidden" : ""
                }`}
              disabled={isReadonly}
            >
              <Plus size={16} className="mr-1" />
              Add Role
            </button>
          </div>
          {editedJobdesc.Roles_and_Responsibilities?.map((role, i) => (
            <div key={i} className="mb-2 dark:text-gray-300 text-textSecondary flex items-center">
              <span className="w-8 text-right pr-2">{i + 1}.</span>
              <textarea
                value={role}
                disabled={isReadonly}
                onChange={(e) => {
                  const newRoles = [
                    ...editedJobdesc.Roles_and_Responsibilities,
                  ];
                  newRoles[i] = e.target.value;
                  const updatedJobdesc = { ...editedJobdesc };
                  updatedJobdesc.Roles_and_Responsibilities = newRoles;
                  setEditedJobdesc(updatedJobdesc);
                }}
                className={`flex-1 ${theme === 'dark' ? 'text-gray-300 px-2 glass-effect' : "text-textSecondary bg-bgPrimary px-2"} focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 min-h-[60px]`}
              />
              <button
                onClick={() =>
                  handleRemoveListItem("Roles_and_Responsibilities", null, i)
                }
                disabled={isReadonly}
                className={`ml-2 text-red-400 hover:text-red-300 ${isReadonly ? "hidden" : ""
                  }`}
              >
                <X size={16} />
              </button>
            </div>
          ))}
        </div>

        {/* Tools & Technologies */}
        <div className="mb-5">
          <div className="flex justify-between items-center mb-3">
            <label className="font-semibold dark:text-white text-textSecondary">
              Tools & Technologies:
            </label>
            <button
              onClick={() => handleAddListItem("Tools_and_Technologies")}
              className={`text-green-400 hover:text-green-300 flex items-center ${isReadonly ? "hidden" : ""
                }`}
              disabled={isReadonly}
            >
              <Plus size={16} className="mr-1" />
              Add Tool
            </button>
          </div>
          {editedJobdesc.Tools_and_Technologies?.map((tool, i) => (
            <div key={i} className="mb-2 dark:text-gray-300 text-textSecondary flex items-center">
              <span className="w-8 text-right pr-2">{i + 1}.</span>
              <input
                type="text"
                disabled={isReadonly}
                value={tool}
                onChange={(e) => {
                  const newTools = [...editedJobdesc.Tools_and_Technologies];
                  newTools[i] = e.target.value;
                  const updatedJobdesc = { ...editedJobdesc };
                  updatedJobdesc.Tools_and_Technologies = newTools;
                  setEditedJobdesc(updatedJobdesc);
                }}
                className={`flex-1 ${theme === 'dark' ? "text-gray-300 glass-effect" : "text-textSecondary bg-bgPrimary"} focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 px-2`}
              />
              <button
                onClick={() =>
                  handleRemoveListItem("Tools_and_Technologies", null, i)
                }
                disabled={isReadonly}
                className={`ml-2 text-red-400 hover:text-red-300 ${isReadonly ? "hidden" : ""
                  }`}
              >
                <X size={16} />
              </button>
            </div>
          ))}
        </div>

        {/* Good to Have */}
        <div className="mb-5">
          <div className="flex justify-between items-center mb-3">
            <label className="font-semibold dark:text-gray-300 text-textSecondary">Good to Have:</label>
            <button
              onClick={() => handleAddListItem("GoodtoHave")}
              disabled={isReadonly}
              className={`text-green-400 hover:text-green-300 flex items-center ${isReadonly ? "hidden" : ""
                }`}
            >
              <Plus size={16} className="mr-1" />
              Add Item
            </button>
          </div>
          {editedJobdesc.GoodtoHave?.map((item, i) => (
            <div key={i} className="mb-2 dark:text-gray-300 text-textSecondary flex items-center">
              <span className="w-8 text-right pr-2">{i + 1}.</span>
              <input
                type="text"
                disabled={isReadonly}
                value={item}
                onChange={(e) => {
                  const newItems = [...editedJobdesc.GoodtoHave];
                  newItems[i] = e.target.value;
                  const updatedJobdesc = { ...editedJobdesc };
                  updatedJobdesc.GoodtoHave = newItems;
                  setEditedJobdesc(updatedJobdesc);
                }}
                className={`flex-1 ${theme === 'dark' ? "text-gray-300 glass-effect" : "text-textSecondary bg-bgPrimary"} focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 px-2`}
              />
              <button
                onClick={() => handleRemoveListItem("GoodtoHave", null, i)}
                disabled={isReadonly}
                className={`ml-2 text-red-400 hover:text-red-300 ${isReadonly ? "hidden" : ""
                  }`}
              >
                <X size={16} />
              </button>
            </div>
          ))}
        </div>

        {/* Pre_Written_Questions */}
        {editedJobdesc?.Pre_Written_Questions && <div className="mb-5">
          <div className="flex justify-between items-center mb-3">
            <label className="font-semibold dark:text-gray-300 text-textSecondary">Sample Questions :</label>
            {/* <button
              onClick={() => handleAddListItem("GoodtoHave")}
              disabled={isReadonly}
              className={`text-green-400 hover:text-green-300 flex items-center ${isReadonly ? "hidden" : ""
                }`}
            >
              <Plus size={16} className="mr-1" />
              Add Item
            </button> */}
          </div>
          {editedJobdesc?.Pre_Written_Questions &&
            Object.entries(editedJobdesc.Pre_Written_Questions).map(
              ([category, questions], catIndex) => (
                <div key={catIndex} className="mb-4">
                  <h3 className="font-normal mb-2 text-sm flex items-center gap-2 dark:text-gray-300 text-textSecondary ml-3">
                    <span className="w-1.5 h-1.5 rounded-full dark:bg-gray-300 bg-gray-800"></span>
                    {category}
                  </h3>


                  {questions.map((q, i) => (
                    <div
                      key={i}
                      className="mb-2 dark:text-gray-300 text-textSecondary flex items-center"
                    >
                      <span className="w-8 text-right pr-2">{i + 1}.</span>

                      <input
                        type="text"
                        disabled={isReadonly}
                        value={q.question}
                        onChange={(e) => {
                          const updated = structuredClone(editedJobdesc);

                          // Update question
                          updated.Pre_Written_Questions[category][i].question = e.target.value;

                          // Remove topic ONLY the first time it is edited
                          if (!updated.Pre_Written_Questions[category][i].edited) {
                            updated.Pre_Written_Questions[category][i].edited = true;

                            const topicToRemove =
                              updated.Pre_Written_Questions[category][i].topic;

                            if (updated.Topics_To_Ask?.[category]) {
                              updated.Topics_To_Ask[category] =
                                updated.Topics_To_Ask[category].filter(
                                  (t) => t !== topicToRemove
                                );
                            }
                          }

                          setEditedJobdesc(updated);
                        }}
                        className={`flex-1 ${
                          theme === "dark"
                            ? "text-gray-300 glass-effect"
                            : "text-textSecondary bg-bgPrimary"
                        } rounded-lg py-3 px-2`}
                      />


                      {/* {!isReadonly && (
                        <button
                          onClick={() =>
                            handleRemoveListItem("Pre_Written_Questions", category, i)
                          }
                          className="ml-2 text-red-400 hover:text-red-300"
                        >
                          <X size={16} />
                        </button>
                      )} */}
                    </div>
                  ))}
                </div>
              )
            )}

        </div>}

      </div>
    );
  };

  const handleSaveJDEdits = async () => {
    setIsLoading(true);

    if (editedJobdesc.minExp > editedJobdesc.maxExp) {
      toast.error(
        "Maximum experience must be greater than minimum experience!"
      );
      setIsLoading(false);
      return;
    }

    try {
      const updatedData = {
        jd_id: selectedID,
        description: editedJobdesc,
      };

      const response = await axios.put(
        `${host}/orgadmin/updatejd`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Job description updated successfully!");
        setJobdesc(editedJobdesc);
        setIsEditingJD(false);
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        if (status === 401) {
          await new Promise((resolve) => {
            sessionStorage.removeItem("accessToken");
            resolve();
          });
          toast.error(`Unauthorized: ${detail}`);
        } else {
          toast.error(`Error: ${detail || "Failed to update job description"}`);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };
  const handleSaveCustomQuestions = async () => {
    const trimmedQuestions = customQuestions.trim();
    if (!trimmedQuestions) {
      setErrorMessage("Please enter custom questions!");
      return;
    }

    setErrorMessage("");
    setIsSavingQuestions(true);

    let isSuccess = false;

    try {
      const response = await axios.post(
        `${host}/upload-custom-questions/`,
        {
          questions: trimmedQuestions,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const { isValid, questions: newQuestions, message } = response.data;
      if (!isValid) {
        setErrorMessage(
          message || "The input does not contain valid questions."
        );
        return;
      }

      const formattedNewQuestions = newQuestions.map((question) => ({
        text: question,
        isNew: true,
      }));

      // Check if adding new questions would exceed the limit
      const totalAfterAdd = questions.length + formattedNewQuestions.length;
      if (totalAfterAdd > 10) {
        setErrorMessage(`Cannot add ${formattedNewQuestions.length} question(s). Maximum 10 questions allowed (currently have ${questions.length})`);
        return; // Exit early, don't add questions
      }

      setQuestions((prevQuestions) => [
        ...prevQuestions,
        ...formattedNewQuestions,
      ]);
      setEditedQuestions((prevEdited) => [
        ...prevEdited,
        ...formattedNewQuestions,
      ]);
      setCustomQuestions("");
      isSuccess = true;
    } catch (error) {
      console.error("Error saving custom questions:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      if (error.response?.status === 400) {
        setErrorMessage(
          error.response.data.message ||
          "The input does not contain valid questions. Please enter valid questions."
        );
      } else if (error.response?.status === 401) {
        setErrorMessage("Authentication failed. Please log in again.");
      } else {
        setErrorMessage(
          "Failed to save custom questions. Please try again or contact support."
        );
      }
    } finally {
      setIsSavingQuestions(false);
      if (isSuccess) {
        setShowAddQuestionsSection(false);
      }
    }
  };

  const handleJobPositionChange = async (e) => {
    const selectedId = e.target.value;
    setSelectedID(selectedId);
    setIsDataLoaded(false);
    if (!selectedId) {
      return;
    }
    try {
      const response = await axios.get(`${host}/getjd`, {
        headers: {
          Authorization: `Bearer ${accessToken.toString()}`,
        },
        params: {
          jd_id: selectedId,
        },
      });
      if (response) {
        setJobData(response.data);
        setJobRole(response.data.jobrole);
        setQuestionType(response.data.questionType || "");
        setJobdesc(response.data.description);
        setEditedJobdesc(JSON.parse(JSON.stringify(response.data.description)));
        setInterviewTimeLimit(response.data.interview_timelimit);
        // Ensure assessment sequence is properly set
        if (
          response.data.assessment_sequence &&
          response.data.assessment_sequence.length > 0
        ) {
          setAssessmentSequence(response.data.assessment_sequence);
        } else {
          // Fallback to default sequence
          let defaultSequence = ["interview"];
          if (response.data.mcq_set_id)
            defaultSequence.unshift("mcq");
          if (response.data.Coding_set && response.data.Coding_set !== "NA")
            defaultSequence.unshift("coding");
          if (response.data.selected_behavioral_set && response.data.selected_behavioral_set !== "NA")
            defaultSequence.unshift("behavioral");
          setAssessmentSequence(defaultSequence);
        }
        if (
          Array.isArray(response.data.customQuestions) &&
          response.data.customQuestions.length > 0
        ) {
          // Initialize questions with isNew: false
          const initialQuestions = response.data.customQuestions.map(
            (question) => ({
              text: question,
              isNew: false,
            })
          );
          setQuestions(initialQuestions);
          setIsCustomQuestionsIncluded(true);
        } else {
          setQuestions([]);
          setIsCustomQuestionsIncluded(false);
        }
        if (response.data.mcq_set_id) {
          setIsMCQIncluded(true);
          setSelectedSet(response.data.mcq_set_id);
        } else {
          setIsMCQIncluded(false);
        }
        if (response.data.Coding_set && response.data.Coding_set !== "NA") {
          setIsCodingIncluded(true);
          setCodingTimeLimit(response.data.coding_time_limit);
          setCodingJudgingCriteria(response.data.Coding_Judge_Criteria);
          setSelectedCodingSet(response.data.Coding_set);
        } else {
          setIsCodingIncluded(false);
        }
        if (response.data.typing_time_limit && response.data.typing_time_limit > 0) {
          setIsTypingIncluded(true);
          setTypingTimeLimit(response.data.typing_time_limit);
        } else {
          setIsTypingIncluded(false);
        }
        if (response.data.selected_behavioral_set && response.data.selected_behavioral_set !== "NA") {
          setIsBehavioralIncluded(true);
          setSelectedBehavioralSet(response.data.selected_behavioral_set);
        } else {
          setIsBehavioralIncluded(false);
        }
        if (response.data.enable_candidate_form) {
          setIsCandidateFormIncluded(true);
        } else {
          setIsCandidateFormIncluded(false);
        }
      }
      setIsDataLoaded(true);
    } catch (error) {
      handleApiError(error);
    }
  };
  const handleApiError = (error) => {
    if (error.response) {
      const status = error.response.status;
      const detail = error.response.data.detail;
      if (status === 401) {
        sessionStorage.removeItem("accessToken");
        toast.error(`Unauthorized: ${detail}`);
      } else if (status === 404) {
        toast.warning(`Not Found: ${detail}`);
      } else {
        toast.error(`Error: ${detail}`);
      }
    } else {
      toast.error("An unexpected error occurred. Please try again.");
    }
  };
  const handleSaveGeneralConfig = async () => {
    if (
      resumeScoreThreshold <= 0 ||
      resumeScoreThreshold >= 100 ||
      !resumeScoreThreshold
    ) {
      toast.warn("Provide a correct Resume Score Threshold!");
      return;
    }
    try {
      const data = await axios.post(
        `${host}/save-config`,
        {},
        {
          params: {
            resume_score_threshold: resumeScoreThreshold,
            language: selectedLanguage,
            voice_name: selectedVoice.name,
            voice_type: selectedVoice.type,
            video_included: isVideoIncluded,
          },
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (data.status === 200) {
        toast.success("Configuration saved successfully!");
      }
    } catch (error) {
      toast.error("Failed to save configuration!");
      console.error("Error:", error);
    }
  };
  const handleSaveChanges = async (e) => {
    e.preventDefault();
    if (
      interview_timelimit == null ||
      isNaN(interview_timelimit) ||
      interview_timelimit < 5
    ) {
      toast.error("Interview time limit should be at least 5 minutes.");
      return;
    }
    if (isTypingIncluded && typingTimeLimit < 1) {
      toast.error("Typing time limit should be at least 1 minute.");
      return;
    }
    if (isCodingIncluded && CodingTimeLimit < 10) {
      toast.error("Coding time limit should be greater than 10 minutes.");
      return;
    }
    if (isMCQIncluded && !selectedSet) {
      toast.error("Please select an MCQ set.");
      return;
    }
    if (
      isCodingIncluded &&
      (selectedCodingSet === "NA" || !selectedCodingSet)
    ) {
      toast.error("Please select a Coding set.");
      return;
    }
    if (isCodingIncluded && !codingJudgingCriteria) {
      toast.error("Please select Coding Judge Criteria.");
      return;
    }
    if (isBehavioralIncluded && (!selectedBehavioralSet || selectedBehavioralSet === "NA")) {
      toast.error("Please select a Behavioural set.");
      return;
    }

    if (isCustomQuestionsIncluded && questions.length === 0) {
      toast.error("Please add at least one custom question.");
      return;
    }
    try {
      const dataToSend = {
        jd_id: selectedID,
        interview_timelimit: interview_timelimit,
        // Time limit and pass mark are no longer sent from here — the backend
        // derives both straight from the chosen MCQ set, their only author.
        selectedSet: isMCQIncluded ? selectedSet : "NA",
        selectedCodingSet: isCodingIncluded ? selectedCodingSet : "NA",
        CodingTimeLimit: isCodingIncluded ? CodingTimeLimit : 0,
        codingJudgingCriteria: isCodingIncluded ? codingJudgingCriteria : "NA",
        enable_candidate_form: testPermissions.candidate_form_enabled ? isCandidateFormIncluded : false,
        typingTimeLimit: isTypingIncluded ? typingTimeLimit : 0,
        // Empty string, not "NA" — process_assessment_configurations does
        // `selectedBehavioralSet or None`, and every behavioral_status gate in this
        // codebase checks selected_behavioral_set's own truthiness directly (unlike
        // mcq_set_id, whose downstream gating reads mcq_time_limit instead), so a
        // literal "NA" string here would read as "a set is selected".
        selectedBehavioralSet: isBehavioralIncluded ? selectedBehavioralSet : "",
        custom_questions: isCustomQuestionsIncluded
          ? questions.map((q) => q.text) 
          : [],
        assessmentSequence: assessmentSequence,
      };
      console.log("Data being sent:", dataToSend);
      const response = await axios.post(
        `${host}/orgadmin/assessment-configurations`,
        dataToSend,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response) {
        toast.success("Job Description Updated Successfully!");
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        if (status === 401) {
          await new Promise((resolve) => {
            sessionStorage.removeItem("accessToken");
            resolve();
          });
          toast.error(`Unauthorized: ${detail}`);
        } else if (status === 404) {
          toast.warning(`Not Found: ${detail}`);
        } else {
          toast.error(`Error: ${detail}`);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };
  console.log("jobPositions:", jobPositions);
  console.log("sets:", sets);
  console.log("codingSets:", codingSets);
  console.log("voices:", voices);
  console.log("languages:", languages);
  console.log("questions:", questions);
  console.log("assessmentSequence:", assessmentSequence);

  const getAssessmentDisplayName = (t) => ({ interview: 'AI Interview', typing: 'Typing Test', mcq: 'MCQ', coding: 'Coding', behavioral: 'Behavioural Assessment' }[t] || t);

  return (
    <div className="max-w-6xl p-4 md:p-8">
      {/* Add Back Button */}
      <div className="mb-6">
        <button
          onClick={() => navigate(-1)}
          className="dark:glass-effect bg-bgSecondary flex items-center gap-2 px-4 py-2 dark:text-white text-textPrimary rounded-lg dark:hover:bg-blue-600/20 hover:bg-gray-200 transition-colors border border-gray-100"
        >
          <ArrowLeft className="w-5 h-5 dark:text-white text-textPrimary" />
          <span>Back</span>
        </button>
      </div>
      <div className={`${theme === 'dark' ? 'glass-effect ' : 'bg-bgSecondary'} backdrop-blur-[50px] rounded-lg shadow-sm border border-gray-100 mb-4`}>
        <button
          onClick={() => setIsEditingJD(!isEditingJD)}
          className="w-full flex items-center justify-between p-6"
        >
          <div className="flex items-center gap-3">
            <code className="text-blue-600">{"</>"}</code>
            <h2 className="text-xl font-semibold dark:text-white text-textPrimary">
              {`${isReadonly ? "View" : "Edit"} Job Description`}
            </h2>
          </div>
          <ChevronDown
            className={`w-5 h-5 dark:text-white text-textPrimary transition-transform ${isEditingJD ? "rotate-180" : ""
              }`}
          />
        </button>
        {isEditingJD && (
          <div className="p-6 border-t border-gray-100">
            <div className="max-w-5xl mx-auto space-y-8">
              <div className="relative">
                <label className="block text-sm font-medium dark:text-white text-textPrimary mb-2">
                  Select Job Role
                </label>
                {/* <select
                  value={selectedID}
                  disabled={isReadonly}
                  onChange={handleJobPositionChange}
                  className={`dark:text-gray-300 text-textSecondary w-full ${theme === 'dark' ? 'glass-effect' : 'bg-bgPrimary'} focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 px-2`}
                >
                  <option
                    value=""
                    style={{
                      background: `${theme === 'dark' && 'rgba(34, 52, 97, 0.35)'}`,
                      color: "black",
                    }}
                    disabled
                  >
                    Select Job Role
                  </option>
                  {Object.keys(jobPositions || {}).length > 0
                    ? Object.entries(jobPositions || {}).map(
                      ([id, position]) => (
                        <option
                          key={id}
                          value={id}
                          style={{
                            background: `${theme === 'dark' && 'rgba(34, 52, 97, 0.35)'}`,
                            color: "black",
                          }}
                        >
                          {position.job_role}
                        </option>
                      )
                    )
                    : Array.from({ length: 5 }).map((_, index) => (
                      <option key={index} disabled>
                        Loading...
                      </option>
                    ))}
                </select> */}
                <input
                  type="text"
                  value={
                    selectedID && jobPositions?.[selectedID]
                      ? jobPositions[selectedID].job_role
                      : ''
                  }
                  placeholder="Select Job Role"
                  readOnly
                  disabled={isReadonly}
                  className={`dark:text-gray-300 text-textSecondary w-full ${
                    theme === 'dark' ? 'glass-effect' : 'bg-bgPrimary'
                  } focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 px-2`}
                />

              </div>
              {/* Show content only when a job is selected */}
              {selectedID && jobdesc && formatJobDescriptionForEditing(jobRole)}
              {selectedID && jobdesc && !isReadonly && (
                <div className="flex justify-end">
                  <button
                    onClick={handleSaveJDEdits}
                    disabled={
                      editedJobdesc.minExp > editedJobdesc.maxExp || isReadonly
                    }
                    className={`button bg-blue-600 text-white hover:bg-blue-700 transition-colors ${editedJobdesc.minExp > editedJobdesc.maxExp
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                      }`}
                  >
                    <span className="flex gap-2 items-center">
                      <Save className="w-4 h-4" />
                      Save Changes
                    </span>
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div className={`${theme === 'dark' ? 'glass-effect backdrop-blur-[50px]' : 'bg-bgSecondary '} rounded-lg shadow-sm border border-gray-100 mb-4`}>
        <button
          onClick={handleAccordionChange}
          className="w-full flex items-center justify-between p-6"
        >
          <div className="flex items-center gap-3">
            <code className="text-blue-600">{"</>"}</code>
            <h2 className="text-xl font-semibold dark:text-white text-textPrimary">
              Assessment Configuration
            </h2>
          </div>
          <ChevronDown
            className={`w-5 h-5 dark:text-white text-textSecondary transition-transform ${expanded ? "rotate-180" : ""
              }`}
          />
        </button>
        {expanded && (
          <div className="p-6 border-t border-gray-100">
            {isLoading ? (
              <div className="flex justify-center items-center py-8">
                <svg
                  className="animate-spin h-8 w-8 text-blue-600"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <span className="ml-3 text-white">Loading...</span>
              </div>
            ) : (
              <div className="max-w-5xl mx-auto space-y-8">
                <div className="mb-5">
                  <label className="block mb-2 font-semibold dark:text-white text-textSecondary">
                    Role:
                  </label>
                  <input
                    type="text"
                    value={jobRole}
                    disabled
                    className={`${theme === 'dark' ? 'text-gray-300 glass-effect' : 'text-textSecondary bg-bgPrimary'} w-full focus:ring-1 focus:ring-gray-500 focus:border-blue-500 rounded-lg py-3 px-2`}
                  />
                </div>
                {selectedID && jobdesc && (
                  <div className="space-y-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="relative">
                        <h3 className="text-lg font-medium dark:text-white text-textSecondary mb-4">
                          Interview Time Limit(in mins)
                        </h3>
                        <div className="relative">
                          <Timer className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 dark:text-gray-300 text-textSecondary" />
                          <input
                            min="5"
                            max="90"
                            type="number"
                            disabled={isReadonly}
                            value={interview_timelimit ?? ""}
                            onChange={(e) => {
                              const value =
                                e.target.value === ""
                                  ? null
                                  : parseInt(e.target.value);
                              setInterviewTimeLimit(value);
                            }}
                            className={`${theme === 'dark' ? 'text-gray-300 glass-effect ' : 'text-textSecondary'} w-full pl-12 pr-4 py-3 rounded-lg focus:ring-1 focus:ring-gray-500 focus:border-blue-500`}
                            placeholder="Interview Time Limit (minutes)"
                          />
                        </div>
                      </div>
                      <div>
                        <div className="flex items-center justify-between mb-4">
                          <h3 className="text-lg font-medium dark:text-white text-textSecondary">
                            Custom Questions
                          </h3>
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              checked={isCustomQuestionsIncluded}
                              disabled={isReadonly}
                              onChange={() => {
                                setIsCustomQuestionsIncluded(
                                  !isCustomQuestionsIncluded
                                );
                                if (!isCustomQuestionsIncluded)
                                  setQuestions([]);
                              }}
                              className="sr-only peer"
                            />
                            <div className="w-11 h-6 bg-gray-400 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-400 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-pink-500"></div>
                          </label>
                        </div>
                        <p className="dark:text-white text-textSecondary">
                          (Custom Questions to be asked in AI Interview)
                        </p>
                      </div>
                    </div>
                    {isCustomQuestionsIncluded && (
                      <div className="space-y-4">
                        {questions.length === 0 && !showAddQuestionsSection ? (
                          <>
                            {/* Single-line input with Save button inside */}
                            <div className="relative">
                              <input
                                type="text"
                                value={customQuestions}
                                onChange={(e) => {
                                  setCustomQuestions(e.target.value);
                                  setErrorMessage("");
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSaveCustomQuestions();
                                  }
                                }}
                                disabled={isReadonly}
                                className={`${theme === 'dark' ? 'text-gray-300 glass-effect' : 'text-textSecondary bg-bgPrimary'} 
                                  focus:ring-1 focus:ring-gray-500 focus:border-blue-500 
                                  w-full pr-32 pl-4 py-4 rounded-lg ${errorMessage ? "border-red-500 border" : ""}`}
                                placeholder="Enter custom questions (one per line if multiple)..."
                              />
                              {!isReadonly && (
                                <button
                                  onClick={handleSaveCustomQuestions}
                                  disabled={isSavingQuestions || !customQuestions.trim()}
                                  className="absolute right-2 top-1/2 -translate-y-1/2 "
                                >
                                  {isSavingQuestions ? (
                                    <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        
                                      />
                                    </svg>
                                  ) : <button 
                                        className={`${theme === 'dark' ? 'button !text-white' : 'border-btn !text-textPrimary'} text-[13px] min-w-[25px] px-4 py-2.5  transition-transform flex items-center justify-center dark:!text-white`}
                                          style={{
                                          color:theme === 'dark' && 'white !important'
                                        }}
                                        ><span>Save</span></button>}
                                  {/* <span className="text-sm">Save</span> */}
                                </button>
                              )}
                            </div>

                            {errorMessage && (
                              <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
                            )}
                          </>
                        ) : (
                          <div className="space-y-4">
                            <div className="max-h-[300px] overflow-y-auto space-y-3">
                              {(questions || []).map((question, index) => (
                                <div key={index} className="relative"> {/* Wrapper for absolute positioning */}
                                  <div className={`flex-1 rounded-2xl border border-white relative pr-12 ${theme === 'dark' ? 'glass-effect' : 'bg-bgPrimary'}`}>
                                    <input
                                      value={question.text}
                                      disabled={isReadonly}
                                      onChange={(e) => {
                                        const updatedQuestions = [...questions];
                                        updatedQuestions[index] = {
                                          ...updatedQuestions[index],
                                          text: e.target.value,
                                        };
                                        setQuestions(updatedQuestions);
                                      }}
                                      className={`w-full p-3 rounded-2xl border border-transparent focus:ring-gray-500 focus:border-transparent dark:text-gray-300 text-textSecondary ${
                                        question.isNew 
                                          ? "bg-transparent" 
                                          : "bg-transparent"
                                      }`}
                                      placeholder="Enter question..."
                                    />
                                    {!isReadonly && (
                                      <button
                                        onClick={() =>
                                          setQuestions(questions.filter((_, i) => i !== index))
                                        }
                                        className="absolute right-3 top-1/2 -translate-y-1/2 p-2 text-red-500 hover:bg-red-500/10 rounded-lg transition-colors"
                                      >
                                        <X className="w-5 h-5" />
                                      </button>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                            {!showAddQuestionsSection && !isReadonly && (
                              <div className="flex justify-between items-center w-full mt-3">
                                <div className={`text-sm ${questions.length >= 10 ? 'text-red-500 font-medium' : 'dark:text-gray-400 text-textSecondary'}`}>
                                  {questions.length} / 10 questions
                                  {questions.length >= 10 && ' (Maximum reached)'}
                                </div>
                                <button
                                  onClick={handleAddQuestion}
                                  disabled={isReadonly || questions.length >= 10}
                                  className={`${theme === 'dark' ? 'button' : 'border-btn !text-textPrimary'} text-[13px] min-w-[25px] px-4 py-2.5 text-white transition-transform flex items-center justify-center ${questions.length >= 10 ? 'opacity-50 cursor-not-allowed' : ''}`}
                                >
                                  <span>Add Question</span>
                                </button>
                              </div>
                            )}
                            {showAddQuestionsSection && (
                              <div className="space-y-4">
                                <div className="relative">
                                  <input
                                    type="text"
                                    value={customQuestions}
                                    onChange={(e) => {
                                      setCustomQuestions(e.target.value);
                                      setErrorMessage("");
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter" && !e.shiftKey) {
                                        e.preventDefault();
                                        handleSaveCustomQuestions();
                                      }
                                    }}
                                    disabled={isReadonly}
                                    className={`${theme === 'dark' ? 'text-gray-300 glass-effect' : 'text-textSecondary bg-bgPrimary'} 
                                      focus:ring-1 focus:ring-gray-500 focus:border-blue-500 
                                      w-full pr-32 pl-4 py-4 rounded-lg ${errorMessage ? "border-red-500 border" : ""}`}
                                    placeholder="Enter custom questions (one per line if multiple)..."
                                  />
                                  {!isReadonly && (
                                    <div className="absolute right-2 top-1/2 -translate-y-1/2 flex gap-2">
                                      <button
                                        onClick={handleSaveCustomQuestions}
                                        disabled={isSavingQuestions || !customQuestions.trim()}
                                        className="px-5 py-2 button transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                                      >
                                        {isSavingQuestions ? (
                                          <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                          </svg>
                                        ) : (
                                        <span className="text-sm">Save</span>
                                        )}
                                      </button>
                                      <button
                                        onClick={handleCancelAddQuestions}
                                        className={`${theme === 'dark' ? 'button' : 'border-btn !text-textPrimary'} disabled:opacity-50 disabled:cursor-not-allowed px-4 py-2.5`}
                                      >
                                        <span>Cancel</span>
                                      </button>
                                    </div>
                                  )}
                                </div>
                                {/* Error Messages */}
                                {errorMessage && (
                                  <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
                                )}
                                <div className="flex gap-2">
                                  {/* Commented Save and Cancel Buttons */}
                                  {!isReadonly && (
                                    // <>
                                    //   <div className="relative items-center rounded-lg flex justify-end">
                                    //     <button
                                    //       onClick={handleSaveCustomQuestions}
                                    //       className="flex gap-2 button px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 transition-colors"
                                    //       disabled={isSavingQuestions}
                                    //     >
                                    //       <span>Save Questions</span>
                                    //       {isSavingQuestions && (
                                    //       <svg
                                    //         className="animate-spin h-5 w-5 ml-3 text-blue-600"
                                    //         xmlns="http://www.w3.org/2000/svg"
                                    //         fill="none"
                                    //         viewBox="0 0 24 24"
                                    //       >
                                    //         <circle
                                    //           className="opacity-25"
                                    //           cx="12"
                                    //           cy="12"
                                    //           r="10"
                                    //           stroke="currentColor"
                                    //           strokeWidth="4"
                                    //         ></circle>
                                    //         <path
                                    //           className="opacity-75"
                                    //           fill="currentColor"
                                    //           d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    //         ></path>
                                    //       </svg>
                                    //     )}
                                    //     </button>
                                    //   </div>
                                    //   <button
                                    //     onClick={handleCancelAddQuestions}
                                    //     className={`${theme === 'dark' ? 'button' : 'border-btn'} disabled:opacity-50 disabled:cursor-not-allowed px-4 py-2.5`}
                                    //   >
                                    //     <span>Cancel</span>
                                    //   </button>
                                    // </>
                                    <>
                                    </>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                    {/* MCQ, Coding, and Typing Settings Grid */}
                    {/* MCQ, Coding, and Typing Settings Grid */}
                    <div className="grid md:grid-cols-2 gap-8">
                      {/* MCQ Settings - Only show if permission granted */}
                      <div className={`space-y-4 ${!testPermissions.mcq_enabled ? "opacity-60" : ""}`}>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <h3 className="text-lg font-medium dark:text-white text-textSecondary">
                              Knowledge Test Settings
                            </h3>
                            {!testPermissions.mcq_enabled && (
                              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-gradient-to-r from-pink-500/20 to-blue-500/20 border border-pink-500/30 dark:text-pink-300 text-pink-600">
                                ✦ Upgrade Plan
                              </span>
                            )}
                          </div>
                          <label className={`relative inline-flex items-center ${!testPermissions.mcq_enabled ? "cursor-not-allowed" : "cursor-pointer"}`}>
                            <input
                              disabled={isReadonly || !testPermissions.mcq_enabled}
                              type="checkbox"
                              checked={isMCQIncluded}
                              onChange={(e) => testPermissions.mcq_enabled && setIsMCQIncluded(e.target.checked)}
                              className="sr-only peer"
                            />
                            <div className="w-11 h-6 bg-gray-400 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-400 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-pink-500"></div>
                          </label>
                        </div>
                          {isMCQIncluded && (
                            <div className="space-y-4">
                              <select
                                value={selectedSet}
                                onChange={(e) =>
                                  setSelectedSet(e.target.value)
                                }
                                disabled={isReadonly}
                                className={`${theme === 'dark' ? 'glass-effect text-gray-300' : 'bg-bgPrimary text-textSecondary'} w-full p-3 rounded-lg focus:ring-1 focus:ring-gray-500 focus:border-blue-500`}
                              >
                                <option
                                  value=""
                                  style={{
                                    background: `${theme === 'dark' ? 'rgba(34, 52, 97, 0.35)' : '#ffffff'}`,
                                    color: "black",
                                  }}
                                >
                                  Select MCQ Set
                                </option>
                                {(sets || []).map((set) => (
                                  <option
                                    key={set.id}
                                    value={set.id}
                                    style={{
                                      background: `${theme === 'dark' ? 'rgba(34, 52, 97, 0.35)' : '#ffffff'}`,
                                      color: "black",
                                    }}
                                  >
                                    {set.name}
                                  </option>
                                ))}
                              </select>
                              {(() => {
                                const info = (sets || []).find(
                                  (set) => set.id === selectedSet
                                );
                                if (!info) return null;
                                return (
                                  <p className="text-xs dark:text-gray-400 text-textSecondary">
                                    {[
                                      info.question_count
                                        ? `${info.question_count} questions`
                                        : null,
                                      info.timelimit ? `${info.timelimit} min` : null,
                                      info.pass_percent != null
                                        ? `pass at ${info.pass_percent}%`
                                        : null,
                                    ]
                                      .filter(Boolean)
                                      .join(" · ")}
                                  </p>
                                );
                              })()}
                            </div>
                          )}
                        </div>
                      

                      {/* Coding Settings - Only show if permission granted */}
                      <div className={`space-y-4 ${!testPermissions.coding_enabled ? "opacity-60" : ""}`}>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <h3 className="text-lg font-medium dark:text-white text-textSecondary">
                              Coding Settings
                            </h3>
                            {!testPermissions.coding_enabled && (
                              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-gradient-to-r from-pink-500/20 to-blue-500/20 border border-pink-500/30 dark:text-pink-300 text-pink-600">
                                ✦ Upgrade Plan
                              </span>
                            )}
                          </div>
                          <label className={`relative inline-flex items-center ${!testPermissions.coding_enabled ? "cursor-not-allowed" : "cursor-pointer"}`}>
                            <input
                              type="checkbox"
                              checked={isCodingIncluded}
                              onChange={(e) => testPermissions.coding_enabled && setIsCodingIncluded(e.target.checked)}
                              disabled={isReadonly || !testPermissions.coding_enabled}
                              className="sr-only peer"
                            />
                            <div className="w-11 h-6 bg-gray-400 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-400 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-pink-500"></div>
                          </label>
                        </div>
                          {isCodingIncluded && (
                            <div className="space-y-4">
                              <select
                                value={selectedCodingSet}
                                onChange={(e) =>
                                  setSelectedCodingSet(e.target.value)
                                }
                                disabled={isReadonly}
                                className={`${theme === 'dark' ? 'glass-effect text-gray-300' : 'bg-bgPrimary text-textSecondary'} w-full p-3 rounded-lg focus:ring-1 focus:ring-gray-500 focus:border-blue-500`}
                              >
                                <option
                                  value=""
                                  style={{
                                    background: `${theme === 'dark' ? 'rgba(34, 52, 97, 0.35)' : '#ffffff'}`,
                                    color: "black",
                                  }}
                                >
                                  Select Coding Set
                                </option>
                                {(codingSets || []).map((set, index) => (
                                  <option
                                    key={index}
                                    value={set}
                                    style={{
                                      background: `${theme === 'dark' ? 'rgba(34, 52, 97, 0.35)' : '#ffffff'}`,
                                      color: "black",
                                    }}
                                  >
                                    {set}
                                  </option>
                                ))}
                              </select>
                              <div className="relative">
                                <Timer className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 dark:text-gray-300 text-textSecondary" />
                                <input
                                  min="10"
                                  type="number"
                                  value={CodingTimeLimit}
                                  onChange={(e) =>
                                    setCodingTimeLimit(
                                      parseInt(e.target.value)
                                    )
                                  }
                                  disabled={isReadonly}
                                  className={`${theme === 'dark' ? 'glass-effect text-gray-300' : 'bg-bgPrimary text-textSecondary'} w-full pl-12 pr-4 py-3 rounded-lg focus:ring-1 focus:ring-gray-500 focus:border-blue-500`}
                                  placeholder="Coding Time Limit (minutes)"
                                />
                              </div>
                              <select
                                value={codingJudgingCriteria}
                                onChange={(e) =>
                                  setCodingJudgingCriteria(e.target.value)
                                }
                                disabled={isReadonly}
                                className={`${theme === 'dark' ? 'glass-effect text-gray-300' : 'bg-bgPrimary text-textSecondary'} w-full p-3 rounded-lg focus:ring-1 focus:ring-gray-500 focus:border-blue-500`}
                              >
                                <option
                                  value=""
                                  style={{
                                    background: `${theme === 'dark' ? 'rgba(34, 52, 97, 0.35)' : '#ffffff'}`,
                                    color: "black",
                                  }}
                                  disabled
                                >
                                  Select Judging Criteria
                                </option>
                                <option
                                  value="0"
                                  style={{
                                    background: `${theme === 'dark' ? 'rgba(34, 52, 97, 0.35)' : '#ffffff'}`,
                                    color: "black",
                                  }}
                                >
                                  AI-based evaluation
                                </option>
                                <option
                                  value="1"
                                  style={{
                                    background: `${theme === 'dark' ? 'rgba(34, 52, 97, 0.35)' : '#ffffff'}`,
                                    color: "black",
                                  }}
                                >
                                  Test-case-based evaluation
                                </option>
                              </select>
                            </div>
                          )}
                        </div>

                      {/* Typing Test Settings - Only show if permission granted */}
                      <div className={`space-y-4 ${!testPermissions.typing_enabled ? "opacity-60" : ""}`}>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <h3 className="text-lg font-medium dark:text-white text-textSecondary">
                              Typing Test Settings
                            </h3>
                            {!testPermissions.typing_enabled && (
                              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-gradient-to-r from-pink-500/20 to-blue-500/20 border border-pink-500/30 dark:text-pink-300 text-pink-600">
                                ✦ Upgrade Plan
                              </span>
                            )}
                          </div>
                          <label className={`relative inline-flex items-center ${!testPermissions.typing_enabled ? "cursor-not-allowed" : "cursor-pointer"}`}>
                            <input
                              type="checkbox"
                              checked={isTypingIncluded}
                              onChange={(e) => testPermissions.typing_enabled && setIsTypingIncluded(e.target.checked)}
                              className="sr-only peer"
                              disabled={isReadonly || !testPermissions.typing_enabled}
                            />
                            <div className="w-11 h-6 bg-gray-400 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-400 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-pink-500"></div>
                          </label>
                        </div>
                          {isTypingIncluded && (
                            <div className="space-y-4">
                              <div className="relative">
                                <Timer className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 dark:text-gray-300 text-textSecondary" />
                                <input
                                  type="number"
                                  min="1"
                                  max="10"
                                  value={typingTimeLimit}
                                  onChange={(e) =>
                                    setTypingTimeLimit(parseInt(e.target.value))
                                  }
                                  className={`${theme === 'dark' ? 'glass-effect text-gray-300' : 'bg-bgPrimary text-textSecondary'} w-full pl-12 pr-4 py-3 rounded-lg focus:ring-1 focus:ring-gray-500 focus:border-blue-500`}
                                  placeholder="Typing Time Limit (minutes)"
                                  disabled={isReadonly}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                    </div>

                    <div className={`space-y-4 ${!testPermissions.behavioral_enabled ? "opacity-60" : ""}`}>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <h3 className="text-lg font-medium dark:text-white text-textSecondary">
                            Behavioural Assessment Settings
                          </h3>
                          {!testPermissions.behavioral_enabled && (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-gradient-to-r from-pink-500/20 to-blue-500/20 border border-pink-500/30 dark:text-pink-300 text-pink-600">
                              ✦ Upgrade Plan
                            </span>
                          )}
                        </div>
                        <label className={`relative inline-flex items-center ${!testPermissions.behavioral_enabled ? "cursor-not-allowed" : "cursor-pointer"}`}>
                          <input
                            type="checkbox"
                            checked={isBehavioralIncluded}
                            onChange={(e) => testPermissions.behavioral_enabled && setIsBehavioralIncluded(e.target.checked)}
                            className="sr-only peer"
                            disabled={isReadonly || !testPermissions.behavioral_enabled}
                          />
                          <div className="w-11 h-6 bg-gray-400 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-400 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-pink-500"></div>
                        </label>
                      </div>
                        {isBehavioralIncluded && (
                          <div className="space-y-4">
                            <select
                              value={selectedBehavioralSet}
                              onChange={(e) =>
                                setSelectedBehavioralSet(e.target.value)
                              }
                              disabled={isReadonly}
                              className={`${theme === 'dark' ? 'glass-effect text-gray-300' : 'bg-bgPrimary text-textSecondary'} w-full p-3 rounded-lg focus:ring-1 focus:ring-gray-500 focus:border-blue-500`}
                            >
                              <option
                                value=""
                                style={{
                                  background: `${theme === 'dark' ? 'rgba(34, 52, 97, 0.35)' : '#ffffff'}`,
                                  color: "black",
                                }}
                              >
                                Select Behavioural Set
                              </option>
                              {(behavioralSets || []).map((set) => (
                                <option
                                  key={set.id}
                                  value={set.id}
                                  style={{
                                    background: `${theme === 'dark' ? 'rgba(34, 52, 97, 0.35)' : '#ffffff'}`,
                                    color: "black",
                                  }}
                                >
                                  {set.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </div>

                    {/* Candidate Form */}
                    {testPermissions.candidate_form_enabled && (
                      <div className="space-y-4">
                        <div className="flex items-center justify-between">
                          <h3 className="text-lg font-medium dark:text-white text-textSecondary">
                            Ask Candidate Details before the test
                          </h3>
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              checked={isCandidateFormIncluded}
                              onChange={() => setIsCandidateFormIncluded(!isCandidateFormIncluded)}
                              disabled={isReadonly}
                              className="sr-only peer"
                            />
                            <div className="w-11 h-6 bg-gray-400 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-400 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-pink-500"></div>
                          </label>
                        </div>
                      </div>
                    )}
                    {(testPermissions.mcq_enabled && isMCQIncluded ||
                      testPermissions.coding_enabled && isCodingIncluded ||
                      testPermissions.typing_enabled && isTypingIncluded ||
                      testPermissions.behavioral_enabled && isBehavioralIncluded) && (
                        <div className="space-y-4">
                          <h3 className="text-lg font-medium dark:text-white text-textSecondary">
                            Assessment Sequence
                          </h3>
                          <p className="text-sm dark:text-gray-400 text-textSecondary">
                            Drag and drop to reorder the assessments
                          </p>
                          <div className="space-y-2">
                            {(assessmentSequence || []).map((assessment) => (
                              <div
                                key={assessment}
                                draggable
                                onDragStart={(e) => handleDragStart(e, assessment)}
                                onDragEnd={handleDragEnd}
                                onDragOver={handleDragOver}
                                onDrop={(e) => handleDrop(e, assessment)}
                                className={`${theme === 'dark' ? 'glass-effect' : 'bg-bgPrimary'} flex items-center gap-3 p-4 border ${theme === 'dark' ? 'border-gray-700' : 'border-gray-200'} rounded-lg cursor-move transition-colors`}
                              >
                                <GripVertical className="w-5 h-5 dark:text-gray-300 text-textSecondary" />
                                <span className="dark:text-gray-300 text-textSecondary font-medium">
                                  {getAssessmentDisplayName(assessment)}
                                </span>
                                {assessment === "interview" && (
                                  <span className="text-xs bg-pink-100 text-pink-700 px-2 py-1 rounded-full ml-auto">
                                    Required
                                  </span>
                                )}
                              </div>
                            ))}
                          </div>
                          <div className="flex items-center gap-2 mt-2">
                            <div className={`flex-1 h-px ${theme === 'dark' ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
                            <span className="text-sm dark:text-white text-textSecondary">
                              Current Sequence:{" "}
                              {assessmentSequence
                                ? assessmentSequence.map(getAssessmentDisplayName).join(" → ")
                                : ""}
                            </span>
                            <div className={`flex-1 h-px ${theme === 'dark' ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
                          </div>
                        </div>
                      )}
                    {!isReadonly && (
                      <div className="flex justify-end pt-4">
                        <button
                          onClick={(e) => {
                            handleSaveChanges(e);
                          }}
                          className="button"
                        >
                          <span className="flex gap-2 items-center">
                            <Save className="w-4 h-4" />
                            Save Changes
                          </span>
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default AssessmentConfig;

